import React, { useState, useEffect, useRef } from "react";
import dropdownIcon from '../../assets/images/iconDropdown.png';
import TimerList from "@/constants/TimerList";

interface Schedule {
    start: string;
    end: string;
    active: boolean;
    isNew: boolean;
}

interface BartenderSchedule {
    sun: Schedule;
    mon: Schedule;
    tue: Schedule;
    wed: Schedule;
    thu: Schedule;
    fri: Schedule;
    sat: Schedule;
}

interface TypeSelectTimeProps {
    disabled: boolean;
    value: string;
    sliceValue: string;
    day: keyof BartenderSchedule;
    field: keyof Schedule;
    onChange?: (day: keyof BartenderSchedule, field: keyof Schedule, newValue: string) => void;
}

const ScheduleSelectTime: React.FC<TypeSelectTimeProps> = ({ day, field, disabled, value, sliceValue, onChange }) => {
    const [inputValue, setInputValue] = useState<string>(value);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const selectRef = useRef<HTMLDivElement>(null);

    const [minIndex, setMinIndex] = useState<number>(0);
    const [maxIndex, setMaxIndex] = useState<number>(0);

    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleSelect = (newValue: string) => {
        setInputValue(newValue);
        setIsOpen(false);
        if (onChange) {
            onChange(day, field, newValue);
        }
    };

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    useEffect(() => {
        if (field === "start") {
            setMinIndex(0);
            setMaxIndex(TimerList.findIndex(obj => obj.value.startsWith(sliceValue)) - 7);
        } else {
            setMinIndex(TimerList.findIndex(obj => obj.value.startsWith(sliceValue)) + 8);
            setMaxIndex(TimerList.length);
        }
    }, [sliceValue]);

    function convertToAMPM(time24: string): string {
        const hour = parseInt(time24.substring(0, 2), 10);
        const minute = time24.substring(3);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const convertedHour = hour % 12 || 12;
        return `${convertedHour}:${minute} ${ampm}`;
    }

    return (
        <div className="w-full relative" ref={selectRef}>
            <div 
                onClick={() => !disabled && setIsOpen(!isOpen)} // Toggle on whole div
                className="w-full flex px-4 py-3 bg-p-gray rounded-full focus:outline-none uppercase focus:ring-1 focus:ring-primary-red text-gray-600 lg:text-base text-sm min-w-32 cursor-pointer"
            >
                <p className={`w-full focus:outline-none ${disabled ? 'text-slate-400' : ''}`}>
                    {!disabled && inputValue ? convertToAMPM(inputValue) : "0"}
                </p>
                {!disabled && (
                    <img src={dropdownIcon} alt="icon" className="h-5 w-5 text-gray-400" />
                )}
            </div>
            {error && <div className="text-red-500 mt-1 ml-2 text-sm">{error}</div>}
            {isOpen && (
                <div className="options-container absolute z-10 h-32 w-full overflow-auto rounded-md bg-white shadow-md px-4">
                    {TimerList.slice(minIndex, maxIndex).map((option, index) => (
                        <div key={index} className="mt-2 hover:bg-slate-100" onClick={() => { handleSelect(option.value); setError(null); }}>
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ScheduleSelectTime;

// import React, { useState, useEffect, useRef } from "react";
// import dropdownIcon from '../../assets/images/iconDropdown.png';
// import TimerList from "@/constants/TimerList";

// interface Schedule {
//     start: string;
//     end: string;
//     active: boolean;
//     isNew: boolean;
// }

// interface BartenderSchedule {
//     sun: Schedule;
//     mon: Schedule;
//     tue: Schedule;
//     wed: Schedule;
//     thu: Schedule;
//     fri: Schedule;
//     sat: Schedule;
// }
// interface TypeSelectTimeProps {
//     disabled: boolean;
//     value: string;
//     sliceValue: string;
//     // Other props...
//     day: keyof BartenderSchedule; // Use keyof BartenderSchedule instead of string
//     field: keyof Schedule; // Use keyof Schedule instead of string
//     onChange?: (day: keyof BartenderSchedule, field: keyof Schedule, newValue: string) => void; // Define onChange prop with correct types
// }
// const ScheduleSelectTime: React.FC<TypeSelectTimeProps> = ({ day, field, disabled, value, sliceValue, onChange, ...rest }) => {
//     const [inputValue, setInputValue] = useState<string>(value);
//     const [isOpen, setIsOpen] = useState<boolean>(false);
//     const [error, setError] = useState<string | null>(null); // State for error message
//     const selectRef = useRef<HTMLDivElement>(null);

//     const [minIndex, setMinIndex] = useState<number>(0)
//     const [maxIndex, setMaxIndex] = useState<number>(0)



//     useEffect(() => {
//         const handleOutsideClick = (event: MouseEvent) => {
//             if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
//                 setIsOpen(false);
//             }
//         };

//         document.addEventListener("mousedown", handleOutsideClick);
//         return () => {
//             document.removeEventListener("mousedown", handleOutsideClick);
//         };
//     }, []);

//     // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     //     const newValue = e.target.value; // Extract the new value from the event
//     //     setInputValue(newValue);

//     //     // Validate input format
//     //     const isValidFormat = /^([01]\d|2[0-3]):([0-5]\d)$/.test(newValue);
//     //     setError(isValidFormat ? null : "Invalid format. Please use '00:00' format.");

//     //     // Call onChange function with the new value
//     //     if (onChange && isValidFormat) {
//     //         onChange(day, field, newValue);
//     //     }
//     // };

//     const handleSelect = (newValue: string) => {
//         setInputValue(newValue);
//         setIsOpen(false);
//         if (onChange) {
//             onChange(day, field, newValue);
//         }
//     };

//     useEffect(() => {
//         setInputValue(value); // Update inputValue when the value prop changes
//     }, [value]);

//     useEffect(() => {

//         if (field == "start") {
//             setMinIndex(0)
//             setMaxIndex(TimerList.findIndex(obj => obj.value.startsWith(sliceValue)) - 7)
//         } else {
//             setMinIndex(TimerList.findIndex(obj => obj.value.startsWith(sliceValue)) + 8)
//             setMaxIndex(TimerList.length)
//         }
//     }, [sliceValue]);



//     function convertToAMPM(time24: string): string {
//         const hour: number = parseInt(time24.substring(0, 2), 10);
//         const minute: string = time24.substring(3);
//         const ampm: string = hour >= 12 ? 'PM' : 'AM';
//         const convertedHour: number = hour % 12 || 12;
//         return `${convertedHour}:${minute} ${ampm}`;
//     }

//     return (
//         <div className="w-full relative" ref={selectRef}>
//             <div 
//                       className="w-full flex px-4 py-3 bg-p-gray rounded-full    focus:outline-none uppercase focus:ring-1 focus:ring-primary-red text-gray-600 lg:text-base text-sm min-w-32"
            
//             >
//                 {/* <input
//                     type="text"
//                     disabled={disabled}
//                     maxLength={5}
//                     value={!disabled && inputValue ? convertTimeToHours(inputValue) : "0"}
//                     className={`w-1/5 focus:outline-none ${disabled ? 'text-slate-400' : ''}`}
//                     onChange={handleChange}
//                     // onFocus={() => setIsOpen(true)}
//                     onBlur={() => setTimeout(() => setIsOpen(false), 200)}
//                     placeholder="00:00"
//                 /> */}
//                 <p className={`w-full focus:outline-none  ${disabled ? 'text-slate-400' : ''}`} >
//                     {
//                         !disabled && inputValue ? convertToAMPM(inputValue) : "0"
//                     }
//                 </p>

//                 {
//                     !disabled &&
//                     <img onClick={() => { !disabled && setIsOpen(!isOpen) }} src={dropdownIcon} alt="icon" className="h-5 w-5 text-gray-400 cursor-pointer" />

//                 }
//             </div>
//             {error && <div className="text-red-500 mt-1 ml-2 text-sm">{error}</div>} {/* Display error message */}
//             {isOpen && (
//                 <div className="options-container absolute z-10 h-32 w-full overflow-auto rounded-md bg-white shadow-md px-4">
//                     {TimerList.slice(minIndex, maxIndex).map((option, index) => (
//                         <div key={index} className="mt-2 hover:bg-slate-100" onClick={() => { handleSelect(option.value), setError(null) }}>
//                             {option.label}
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ScheduleSelectTime;
